import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type ProjectType = APIResponse<'/api/v4/project-types'>[number];

export const fetchProjectTypes = () => get<ProjectType[]>('/v4/project-types');
